var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-text-field',_vm._g(_vm._b({attrs:{"rules":[_vm.numberRule]}},'app-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }